import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import CEOMessage from './pages/CEOMessage';
import FY22Highlights from './pages/FY22Highlights';
import FY22AwardsAndRecognition from './pages/FY22AwardsAndRecognition';
import OurApproach from './pages/OurApproach';
import Environment from './pages/Environment';
import Social from './pages/Social';
import Governance from './pages/Governance';
import Menu from './components/Menu';
import Footer from './components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import './App.css';

// Initialize AOS (Animate On Scroll) library
AOS.init();

function App() {
  return (
    <>
      {/* Use HashRouter for routing */}
      <Router>
        {/* Render the menu component */}
        <Menu />
        {/* Define routing paths */}
        <Routes>
          <Route path='/'>
            {/* Home page */}
            <Route index element={<Home />} />
            {/* Other pages */}
            <Route path="president-and-ceo-message" element={<CEOMessage />} />
            <Route path="fy2025-highlights" element={<FY22Highlights />} />
            <Route path="fy2025-awards-and-recognition" element={<FY22AwardsAndRecognition />} />
            <Route path="our-approach" element={<OurApproach  />} />
            <Route path="environment" element={<Environment />} />
            <Route path="social" element={<Social />} />
            <Route path="governance" element={<Governance />} />
          </Route>
        </Routes>
      </Router>
      <Footer/>
      <div className='bodyOverlay'>
      </div>
    </>
  );
}

export default App;
